import { CIRCLE_RADIUS } from './constants'

export const calculateCircumference = (radius: number) => 2 * Math.PI * radius

export const calculateStrokeDashoffset = (
  circumference: number,
  percentage: number
) => -circumference + (percentage / 100) * circumference

export const getDefaultCircumference = () =>
  calculateCircumference(CIRCLE_RADIUS)
